<script setup lang="ts">
const props = withDefaults(defineProps<{
  tip: string;
  position?: 'top' | 'bottom';
}>(),
{
  position: 'top',
});

const { tip } = toRefs(props);
</script>

<template>
  <div class="m-tooltip">
    <slot />
    <div :class="`tip ${position}`">
      {{tip}}
    </div>
  </div>
</template>

<style lang="scss">
  .m-tooltip {
    --offset: 0.3em;
    position: relative;
    display: inline-block;

    .tip {
      position: absolute;
      left: 50%;
      padding: 4px 8px;
      margin: var(--offset);
      border-radius: 4px;
      background-color: var(--palette-neutral-90);
      color: #fff;
      font-size: 12px;
      white-space: nowrap;
      opacity: 0;
      transition: opacity 0.2s;
      z-index: 900;
      pointer-events: none;

      &.bottom {
        top: 100%;
        bottom: auto;
        transform: translateX(-50%) translateY(0);
      }

      &.top {
        top: auto;
        bottom: 100%;
        transform: translateX(-50%) translateY(0);
      }
    }

    &:hover {
      .tip {
        opacity: 1;
      }
    }
  }
</style>